import { ReactElement, memo } from 'react';

import { QrCode as QrCodeIcon } from '~components/Icons';

import { OrderMFlexQRCommonProps } from '../types';
import OrderMFlexQRInfo from '../Info';

import { OrderMFlexQRIconWithTooltip } from './styles';

const OrderMFlexQRIconWithTooltipInfo = ({
  qrData,
  referenceId,
  className,
}: OrderMFlexQRCommonProps & { className?: string }): ReactElement => (
  <OrderMFlexQRIconWithTooltip
    title={<OrderMFlexQRInfo qrData={qrData} referenceId={referenceId} />}
    arrow
    placement="right"
  >
    <QrCodeIcon color="action" fontSize="small" className={className} />
  </OrderMFlexQRIconWithTooltip>
);

export default memo(OrderMFlexQRIconWithTooltipInfo);
